import React from 'react';
import StatusMetersPage from './StatusMetersPage';

export default function Rejected() {
  return (
    <StatusMetersPage status="Rejected" title="Commission Rejected" showViewMore />
  );
}
